import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FiDownload, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export default function EmailSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscribers();
  }, [pagination.page]);

  const fetchSubscribers = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/admin/email-subscribers', { params: { page: pagination.page } });
      setSubscribers(data.subscribers);
      setPagination(data.pagination);
    } catch {
      toast.error('Failed to fetch subscribers');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      const response = await api.get('/admin/email-subscribers/export', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'email-subscribers.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('CSV exported!');
    } catch {
      toast.error('Export failed');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700 }}>Email Subscribers</h1>
        <button onClick={handleExport} style={styles.exportBtn}>
          <FiDownload size={16} /> Export CSV
        </button>
      </div>

      <div style={styles.table}>
        <div style={styles.tableHeader}>
          <span style={{ flex: 2 }}>Email</span>
          <span style={{ flex: 1 }}>Name</span>
          <span style={{ flex: 1 }}>Source</span>
          <span style={{ flex: 1 }}>Status</span>
          <span style={{ flex: 1 }}>Date</span>
        </div>
        {subscribers.map(s => (
          <div key={s._id} style={styles.tableRow}>
            <span style={{ flex: 2 }}>{s.email}</span>
            <span style={{ flex: 1, color: 'var(--text-muted)' }}>{s.name || '-'}</span>
            <span style={{ flex: 1 }}>
              <span style={styles.sourceBadge}>{s.source}</span>
            </span>
            <span style={{ flex: 1 }}>
              <span style={{ color: s.isActive ? 'var(--success)' : 'var(--danger)' }}>
                {s.isActive ? 'Active' : 'Unsubscribed'}
              </span>
            </span>
            <span style={{ flex: 1, color: 'var(--text-muted)', fontSize: 13 }}>
              {new Date(s.createdAt).toLocaleDateString()}
            </span>
          </div>
        ))}
      </div>

      <div style={styles.pagination}>
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{pagination.total} total</span>
        <div style={{ display: 'flex', gap: 4 }}>
          <button disabled={pagination.page <= 1} onClick={() => setPagination(p => ({ ...p, page: p.page - 1 }))} style={styles.pageBtn}><FiChevronLeft /></button>
          <span style={{ padding: '6px 12px', fontSize: 14 }}>{pagination.page} / {pagination.pages}</span>
          <button disabled={pagination.page >= pagination.pages} onClick={() => setPagination(p => ({ ...p, page: p.page + 1 }))} style={styles.pageBtn}><FiChevronRight /></button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  exportBtn: { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  table: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' },
  tableHeader: { display: 'flex', padding: '12px 16px', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border)', textTransform: 'uppercase' },
  tableRow: { display: 'flex', padding: '12px 16px', fontSize: 14, color: 'var(--text-primary)', borderBottom: '1px solid var(--border)', alignItems: 'center' },
  sourceBadge: { padding: '2px 8px', background: 'var(--bg-tertiary)', borderRadius: 8, fontSize: 12, textTransform: 'capitalize' },
  pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 },
  pageBtn: { padding: '6px 10px', background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-primary)', cursor: 'pointer', display: 'flex' }
};
